import React from 'react';
type TagProps = {
  children: React.ReactNode;
  tone?: 'green' | 'gold' | 'muted';
  className?: string;
};
const tones: Record<NonNullable<TagProps['tone']>, string> = {
  green: 'text-[#16a34a] border-[#16a34a]/30 bg-[#16a34a]/10',
  gold: 'text-[#d97706] border-[#d97706]/30 bg-[#d97706]/10',
  muted: 'text-slate-400 border-white/15 bg-white/5'
};
export function Tag({
  children,
  tone = 'green',
  className = ''
}: TagProps) {
  return <span className={`inline-block rounded border px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] ${tones[tone]} ${className}`} data-id="element-180" data-mp="3k0fus7brmosy">
      {children}
    </span>;
}